/**
 * The API stores user text HTML-escaped ("A &amp; B" for "A & B"). Decode it
 * once, where responses arrive, so every screen shows the real characters.
 * React escapes on render, so decoding here cannot inject HTML.
 */

const ENTITY = /&(?:#\d+|#x[0-9a-f]+|[a-z]+);/i;

/* Fields that hold text a person typed. URLs, ids and enums are left alone. */
const TEXT_KEYS = new Set([
  'title', 'description', 'text', 'content', 'note', 'resolution_note',
  'message', 'subject', 'name', 'org_name', 'creator_name', 'user_name',
  'assignee_name', 'author_name', 'closed_by_name', 'ticket_title',
  'display_name', 'first_name', 'last_name', 'filename', 'original_filename',
]);

let scratch = null;

export const decodeEntities = (value) => {
  if (typeof value !== 'string' || !ENTITY.test(value)) return value;
  if (!scratch) scratch = document.createElement('textarea');
  scratch.innerHTML = value;
  return scratch.value;
};

/** Walk a response body and decode the text fields in place of a copy. */
export const decodeDeep = (value, key) => {
  if (typeof value === 'string') return key && TEXT_KEYS.has(key) ? decodeEntities(value) : value;
  if (Array.isArray(value)) return value.map((item) => decodeDeep(item, key));
  if (value && typeof value === 'object') {
    const out = {};
    for (const k of Object.keys(value)) out[k] = decodeDeep(value[k], k);
    return out;
  }
  return value;
};
